import { usePage } from "@inertiajs/react"

export default function useCurrentUser() {
  return usePage().props.current_user
}
